import type { HTMLAttributes } from 'react';
import { cx } from '../lib/cx';

export type StatusTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'primary';

export interface StatusDotProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: StatusTone;
  /** Animated "live" pulse (e.g. AI answering / call live). */
  pulse?: boolean;
  /** Accessible label; when omitted the dot is decorative. */
  label?: string;
}

/** Small status dot for line-status / presence indicators. */
export function StatusDot({ tone = 'neutral', pulse = false, label, className, ...rest }: StatusDotProps) {
  return (
    <span
      className={cx('tc-status-dot', `tc-status-dot--${tone}`, pulse && 'tc-status-dot--pulse', className)}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      {...rest}
    />
  );
}
